import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { COLOR } from '@src/styles/color';

const StyledInstructionItem = styled(Box)`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

const StepSymbol = styled(Box)`
  width: 25.6px;
  height: 25.6px;
  border-radius: 50%;
  border: 2px solid ${COLOR.indigo[16]};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const StepSymbolInner = styled(Box)`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${COLOR.indigo.default};
`;

const InstructionContent = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
`;

export {
  StyledInstructionItem,
  StepSymbol,
  StepSymbolInner,
  InstructionContent,
};
